import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";

export default function AdminSettings() {
  const [form, setForm] = useState({ razorpay_key_id: "", razorpay_key_secret: "", platform_fee_percent: 10 });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let alive = true;
    api.get("/admin/settings")
      .then(({ data }) => {
        if (!alive) return;
        setForm((f) => ({ ...f, razorpay_key_id: data.razorpay_key_id || "", platform_fee_percent: data.platform_fee_percent ?? 10 }));
      })
      .catch(() => toast.error("Failed to load settings"))
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, []);

  const save = async () => {
    const fee = Number(form.platform_fee_percent);
    if (!Number.isFinite(fee) || fee < 0 || fee > 100) return toast.error("Platform fee must be between 0 and 100");
    setSaving(true);
    try {
      await api.put("/admin/settings", { ...form, platform_fee_percent: fee });
      toast.success("Saved");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-2xl" data-testid="admin-settings-page">
      <div className="overline mb-2">Configuration</div>
      <h1 className="font-display text-4xl mb-8">Platform Settings</h1>
      <div className="bg-white border border-[hsl(var(--kb-border))] p-6 space-y-5">
        <div>
          <label className="overline block mb-1">Platform Razorpay Key ID</label>
          <input className="kb-input" value={form.razorpay_key_id} onChange={(e) => setForm({ ...form, razorpay_key_id: e.target.value })} data-testid="adm-rzp-id" />
          <p className="text-xs text-[hsl(var(--kb-muted))] mt-1">Used to collect platform fees from sellers.</p>
        </div>
        <div>
          <label className="overline block mb-1">Platform Razorpay Key Secret</label>
          <input type="password" className="kb-input" value={form.razorpay_key_secret} onChange={(e) => setForm({ ...form, razorpay_key_secret: e.target.value })} data-testid="adm-rzp-secret" />
        </div>
        <div>
          <label className="overline block mb-1">Platform Fee (%)</label>
          <input type="number" className="kb-input" value={form.platform_fee_percent} onChange={(e) => setForm({ ...form, platform_fee_percent: Number(e.target.value) })} data-testid="adm-fee" />
        </div>
        <button className="kb-btn-primary" onClick={save} disabled={loading || saving} data-testid="adm-save">{saving ? "Saving…" : "Save Settings"}</button>
      </div>
    </div>
  );
}
